import { render, staticRenderFns } from "./ShoppingCard.vue?vue&type=template&id=651da9d0&scoped=true&"
import script from "./ShoppingCard.vue?vue&type=script&lang=js&"
export * from "./ShoppingCard.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCard.vue?vue&type=style&index=0&id=651da9d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651da9d0",
  null
  
)

export default component.exports